export const errorCodeKeys : { [index: string]: string } = {
    "invalid_phone_number": "passwordless.phoneNumber.error.invalidNumber",
    "passwordless.phoneNumber.error.unexpectedError": "startPasswordless.error.unexpectedError",
    "wrong_number_or_code": "passwordless.verificationCode.error.wrongCode",
    "verify_sms_unexpected": "passwordless.verificationCode.error.unexpected",
    "user_email_not_exist": "passwordless.verificationCode.resendCode.error.userDoesntExist",
    "resend_limit_reached": "passwordless.verificationCode.resendCode.error.limitReached",
    "phone_number_already_linked": "passwordless.verificationCode.error.linkedPhoneNumber",
    "jwt_error": "error.tokenError",
    "missing_token": "error.missingToken",
    "max_login_attempts_exceeded": "passwordless.verificationCode.error.maxLoginAttemptsExceeded"
}
